<mojo-widget (onDashboardDesignerDelete)="bubbleDashboardDesignerDelete($event)" [title]="widget.title" [isDashboardDesignerMode]="true" [widget]="widget">
  <ng-container widget-body>
    <div class="designer-widget-body"></div>
  </ng-container>
</mojo-widget>
